import PropTypes from 'prop-types';
import React from "react";
import FooterPageLayout from "~app/components/layouts/FooterPageLayout";
import { useT } from '~app/BundleProvider';

const Resources = ({ mainRef }) => {
  const t = useT();
  return (
    <FooterPageLayout mainRef={mainRef}>
      <article>
        <h1>{t("overview")}</h1>
        <span
          dangerouslySetInnerHTML={{
              __html: t("overview-description"),
          }}
        />
        
        <h2>{t("key-concepts")}</h2>
        <ul>
          <li>{t("key-concepts-description-1")}</li>
          <li>{t("key-concepts-description-2")}</li>
          <li>{t("key-concepts-description-3")}</li>
          <li>{t("key-concepts-description-4")}</li>
        </ul>
        
        <h2>{t("student-learning-targets")}</h2>
        <ul>
          <li>{t("student-learning-targets-description-1")}</li>
          <li>{t("student-learning-targets-description-2")}</li>
          <li>{t("student-learning-targets-description-3")}</li>
        </ul>

        <h2>{t("suggestions")}</h2>
        <span
          dangerouslySetInnerHTML={{
              __html: t("suggestions-description"),
          }}
        />
        <ul>
          <li>{t("suggestions-description-1")}</li>
          <li>{t("suggestions-description-2")}</li>
          <li>{t("suggestions-description-3")}</li>
          <li>{t("suggestions-description-4")}</li>
        </ul>
      </article>
    </FooterPageLayout>
  );
};

Resources.propTypes = {
  mainRef: PropTypes.func.isRequired,
};

export default Resources;



// WEBPACK FOOTER //
// ./src/pages/Resources.js